export default __webpack_public_path__ + "static/media/pink.7d7ede75.webp";